<div class="simple-sidebar"><div class="simple-sidebar__menu-list"><FAQSidebarBody></FAQSidebarBody></div></div>